import {UnsupportedBlockNode} from './services/UnsupportedBlockNode'
import {UnsupportedBlockNodeConverter} from './services/UnsupportedBlockNodeConverter'
import {UnsupportedBlockNodeComponent} from './UnsupportedBlockNodeComponent'

import {UnsupportedInlineNode} from './services/UnsupportedInlineNode'
import {UnsupportedInlineNodeConverter} from './services/UnsupportedInlineNodeConverter'
import {UnsupportedInlineNodeComponent} from './UnsupportedInlineNodeComponent'

import {TextConverter} from '../text/services/TextConverter'
import {UnsupportedTextComponent} from './UnsupportedTextComponent'
import {UnsupportedTextNode} from './services/UnsupportedTextNode'

import './scss/unsupported.scss'

const UnsupportedPackage = {
    name: 'unsupported',
    configure: function (configurator) {

        // Unsupported blocks
        configurator.addComponent('unsupportedblocknode', UnsupportedBlockNodeComponent)
        configurator.addNode(UnsupportedBlockNode)
        configurator.addConverter(UnsupportedBlockNodeConverter)

        // Unsupported text (elements)
        configurator.addComponent('unsupportedtextnode', UnsupportedTextComponent)
        configurator.addNode(UnsupportedTextNode)
        configurator.addConverter(
            TextConverter({
                type: 'unsupportedtextnode',
                matchElement: (el) => el.is('element')
            })
        )

        // Unsupported inline elements. Complete fallback, must be last in unsupported order.
        configurator.addComponent('unsupportedinlinenode', UnsupportedInlineNodeComponent)
        configurator.addNode(UnsupportedInlineNode)
        configurator.addConverter(UnsupportedInlineNodeConverter)
    }
}

export {UnsupportedPackage}
